var map = {
	"./1/filteredstudents/1/list.json": 2539,
	"./1/filteredstudents/2/list.json": 2540,
	"./1/filteredstudents/3/list.json": 2541,
	"./1/filteredstudents/4/list.json": 2542,
	"./1/filteredstudents/5/list.json": 2543,
	"./1/filteredstudents/6/list.json": 2544
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2538;


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/institutions/assessments ^\.\/.*\/list\.json$
// module id = 2538
// module chunks = 0